module.exports = __webpack_public_path__ + "img/mini_app.c8ae6884.png";